import { displayModal } from "./displayModal";
import { ACCESS_REQUIREMENT_CODES } from "../helpers/accessRequirementErrors";

function getAjaxResponsePayload(xhr) {
    if (xhr?.responseJSON) {
        return xhr.responseJSON;
    }

    if (!xhr?.responseText) {
        return null;
    }

    try {
        return JSON.parse(xhr.responseText);
    } catch (error) {
        return null;
    }
}

/**
 * Catch profile requirements centrally so every chat AJAX action opens the
 * auth modal, including legacy integrations that return a logical failure
 * through an HTTP 200 success callback. Current endpoints use HTTP 403 to
 * avoid both that success path and the HTTP Basic Auth challenge caused by 401.
 */
export function initProfileRequiredAjaxGuard() {
    if (window._growtypeChatProfileRequiredAjaxGuardBound) {
        return;
    }

    window._growtypeChatProfileRequiredAjaxGuardBound = true;

    jQuery(document)
        .off("ajaxComplete.growtypeChatProfileRequired")
        .on("ajaxComplete.growtypeChatProfileRequired", function (_event, xhr) {
            const payload = getAjaxResponsePayload(xhr);
            const requirement = payload?.data?.message ?? payload?.data?.error ?? "";

            if (
                payload?.success !== false ||
                requirement !== ACCESS_REQUIREMENT_CODES.PROFILE_REQUIRED
            ) {
                return;
            }

            const authModal = document.getElementById("growtypeFormAuthModal");
            if (authModal?.classList.contains("show")) {
                return;
            }

            if (!payload.data.message) {
                payload.data.message = requirement;
            }

            handleAjaxError({ responseJSON: payload });
        });
}

export function handleAjaxError(response, submitBtn = null) {
    if (response.statusText === 'abort' || response.status === 0) {
        return;
    }

    window.growtypeModal?.hideAll();

    if (submitBtn) {
        submitBtn.removeClass('is-loading');
        submitBtn.removeClass('is-playing');
    }

    displayModal(response);
}
